import { defineComponent, PropType } from '@vue/composition-api'
import { BTargetCard } from './BTargetCard'

export const BTargetFetchCard = defineComponent({
  name: 'BTargetFetchCard',
  props: {
    id: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 360,
    },
    direction: {
      type: String as PropType<'vertical' | 'horizontal'>,
      default: 'horizontal',
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return {}
  },
  render() {
    return (
      <BTargetCard
        style={{ width: `${this.width}px` }}
        id={this.id}
        direction={this.direction}
        border={this.border}
        onLoaded={() => this.$emit('loaded')}
      ></BTargetCard>
    )
  },
})
